import { useMemo } from 'react';
import { EGridLayout, baseGridStyles } from './constants';

export const getGridDetails = (numItems, layout) => {
  if (layout === EGridLayout.Row) {
    return {
      rows: 1,
      columns: numItems,
    };
  } else {
    let rows, columns;
    const sqrt = Math.sqrt(numItems);
    const floorSqrt = Math.floor(sqrt);
    const ceilSqrt = Math.ceil(sqrt);

    if (floorSqrt * ceilSqrt >= numItems) {
      rows = floorSqrt;
      columns = ceilSqrt;
    } else {
      rows = columns = ceilSqrt;
    }

    return {
      rows,
      columns,
    };
  }
};
export const getGridStyles = (numItems, layout) => {
  const gridStyles = useMemo(() => {
    const { rows, columns } = getGridDetails(numItems, layout);
    return {
      ...baseGridStyles,
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gridTemplateRows: `repeat(${rows}, 1fr)`,
    };
  }, [numItems, layout]);
  return gridStyles;
};
